/**
 * Normalize image URLs for production.
 * Rewrites localhost:5001 (backend-image-upload) URLs to relative paths
 * so they work when served by the main server.
 */
export function getImageUrl(url) {
  if (!url || typeof url !== 'string') return null;
  const trimmed = url.trim();
  if (!trimmed) return null;
  // Already a full URL to current or external origin - use as-is unless it's localhost:5001
  if (trimmed.startsWith('http://localhost:5001/') || trimmed.startsWith('https://localhost:5001/')) {
    return trimmed.replace(/^https?:\/\/localhost:5001/, '');
  }
  // Relative path - use as-is
  if (trimmed.startsWith('/')) return trimmed;
  // Might be a path without leading slash
  return `/${trimmed}`;
}
